var exports = {
  "$": "x4c3adb35--ce7bd9--search",
  "Q": "x4c3adb35--ce7bd9--content",
};

module.exports = exports;
